// extracted by mini-css-extract-plugin
export default {"share-button-container":"qPpsQ","share-button":"D8eEG","fb":"iGX4x"};